import { UrlConstants } from "../url.constants";
export class ApiAttachmentConstants {
    static URL = UrlConstants.API_V2 + "Attachment";
    static FUNCTION_DELETE_MULTIPLE_ATTACHMENTS = "DeleteMultipleAttachments";
    static FUNCTION_GET_ATTACHMENT_CONTENT = "GetAttachmentContent";
    static FUNCTION_GET_ATTACHMENT_CONTENT_BASE_64 = "GetAttachmentContentBase64";
    static FUNCTION_UPLOAD_ATTACHMENT = "UploadAttachment";
    static FUNCTION_UPLOAD_STAMPED_ATTACHMENT = "UploadStampedAttachment";
    static FUNCTION_STAMP_DOCUMENT = "StampDocument";
    static FUNCTION_ENABLE_AFLA_PORTAL_ATTACHMENTS = "EnableAFLAPortalAttachments";
    static FUNCTION_DISABLE_AFLA_PORTAL_ATTACHMENTS = "DisableAFLAPortalAttachments";
    static FUNCTION_UPLOAD_PROJECT_CYCLE_DOCUMENT = "UploadProjectCycleDocument";
    static GET_PROJECT_CYCLE_ATTACHMENTS = "GetProjectCycleAttachments";
}
